import { t } from "@lingui/macro";

import SEO from "components/Common/SEO";
import { getPageTitle } from "../../lib/legacy";
import TMXPhaseCard from "../../components/Launch/TMXPhaseCard/TMXPhaseCard";
import Footer from "../../components/Footer/Footer";
import PhaseFour from "../../components/Launch/PhaseFour/PhaseFour";
import { useState } from "react";
import phaseCardStyles from "../../components/Launch/TMXPhaseCard/TMXPhaseCard.module.scss";

const PHASE_CONFIG = [
  {
    id: 1,
    title: "Phase 1: TMX Private SEED",
    content: (
      <>
        <p className={phaseCardStyles.text}>Participate in the TMX Private SEED</p>
        {/*<p className={phaseCardStyles.text}>*/}
        {/*  To earn airdrops, simply start trading on TMX or deposit assets in the liquidity pool. Users can also*/}
        {/*  participate in various campaigns on Zealy io to acquire experience points which will earn you a share of the*/}
        {/*  airdrops pool.*/}
        {/*</p>*/}
      </>
    ),
    isCompleted: true,
    footerTitle: "Phase 1: Seed Round",
  },
  {
    id: 2,
    title: "Phase 2: TGE",
    content: (
      <>
        <p className={phaseCardStyles.text}>Token Generating Event(TGE)</p>
        {/*<p className={phaseCardStyles.text}>*/}
        {/*  To earn airdrops, simply start trading on TMX or deposit assets in the liquidity pool. Users can also*/}
        {/*  participate in various campaigns on Zealy io to acquire experience points which will earn you a share of the*/}
        {/*  airdrops pool.*/}
        {/*</p>*/}
      </>
    ),
    isCompleted: true,
    footerTitle: "Phase 2: TGE Round",
  },
  {
    id: 3,
    title: "Phase 3: TLP Surge",
    content: (
      <>
        <p className={phaseCardStyles.text}>Deposit TLP and receive rewards</p>
      </>
    ),
    isCompleted: true,
    footerTitle: "Phase 3: TLP Round",
  },
  {
    id: 4,
    title: "Phase 4: Additional platform functionality",
    content: (
      <>
        <p className={phaseCardStyles.text}>Coming soon</p>
      </>
    ),
    isCompleted: false,
    footerTitle: "Phase 4: Live Round",
  },
];

export default function Launch() {
  const [currentPhase, setCurrentPhase] = useState(1);
  return (
    <SEO title={getPageTitle(t`Launch`)}>
      <div className="default-container page-layout">
        <div className="grid grid-cols-1 justify-items-center gap-16 sm:grid-cols-2 lg:grid-cols-4">
          {PHASE_CONFIG.map((item) => {
            return (
              <TMXPhaseCard
                key={item.id}
                item={item}
                setCurrentPhase={setCurrentPhase}
                isActive={currentPhase === item.id}
              />
            );
          })}
        </div>
        {currentPhase === 1 && (
          <PhaseFour item={PHASE_CONFIG.find((item) => item?.id === currentPhase) || { id: currentPhase }} />
        )}
        {currentPhase === 2 && (
          <PhaseFour item={PHASE_CONFIG.find((item) => item?.id === currentPhase) || { id: currentPhase }} />
        )}
        {currentPhase === 3 && (
          <PhaseFour item={PHASE_CONFIG.find((item) => item?.id === currentPhase) || { id: currentPhase }} />
        )}
        {currentPhase === 4 && (
          <PhaseFour item={PHASE_CONFIG.find((item) => item?.id === currentPhase) || { id: currentPhase }} />
        )}

        <Footer />
      </div>
    </SEO>
  );
}
